import deepmerge from 'deepmerge';
export default (function () {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return a === b ? a : deepmerge(a, b);
});